import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type ActionOutcome = 'engaged' | 'no_response' | 'pending';

export interface ActionTimelineEntry {
  id: string;
  actionType: string;
  performedAt: string;
  performedByName: string | null;
  payload: Record<string, unknown> | null;
  outcome: ActionOutcome;
}

export function useMemberActionTimeline(memberId: string | undefined, clubId: string | undefined) {
  return useQuery({
    queryKey: ['member-action-timeline', clubId, memberId],
    queryFn: async (): Promise<ActionTimelineEntry[]> => {
      const { data, error } = await supabase.rpc('get_member_action_timeline', {
        p_member_id: memberId!,
        p_club_id: clubId!,
      });
      if (error) throw error;
      return (data ?? []).map((row: any) => ({
        id: row.id,
        actionType: row.action_type,
        performedAt: row.performed_at,
        performedByName: row.performed_by_name,
        payload: row.payload,
        outcome: row.outcome as ActionOutcome,
      }));
    },
    enabled: !!memberId && !!clubId,
    staleTime: 30 * 1000,
  });
}
